var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateAShipmentOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4644 0.500857C4.60671 0.341265 4.81036 0.25 5.02419 0.25H11.4629C11.6767 0.25 11.8804 0.341265 12.0227 0.500857L16.0469 5.01393C16.1694 5.15133 16.2371 5.32899 16.2371 5.51308V8.65926C16.2371 9.07347 15.9013 9.40926 15.4871 9.40926C15.0729 9.40926 14.7371 9.07347 14.7371 8.65926V6.26308H1.75V16.0308H6.82593C7.24014 16.0308 7.57593 16.3666 7.57593 16.7808C7.57593 17.195 7.24014 17.5308 6.82593 17.5308H1C0.585786 17.5308 0.25 17.195 0.25 16.7808V5.51308C0.25 5.32899 0.317703 5.15133 0.440217 5.01393L4.4644 0.500857ZM2.67361 4.76308H7.49354V1.75H5.36029L2.67361 4.76308ZM8.99354 1.75V4.76308H13.8135L11.1268 1.75H8.99354Z",
    fill: "#FF5F14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0833 13.5833C16.0833 13.2612 15.8222 13 15.5 13C15.1778 13 14.9167 13.2612 14.9167 13.5833V15.9167H12.5833C12.2612 15.9167 12 16.1778 12 16.5C12 16.8222 12.2612 17.0833 12.5833 17.0833H14.9167V19.4167C14.9167 19.7388 15.1778 20 15.5 20C15.8222 20 16.0833 19.7388 16.0833 19.4167V17.0833H18.4167C18.7388 17.0833 19 16.8222 19 16.5C19 16.1778 18.7388 15.9167 18.4167 15.9167H16.0833V13.5833Z",
    fill: "#FF5F14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3407 21.5001C17.9774 21.5001 20.1148 19.3626 20.1148 16.726C20.1148 14.0893 17.9774 11.9519 15.3407 11.9519C12.7041 11.9519 10.5667 14.0893 10.5667 16.726C10.5667 19.3626 12.7041 21.5001 15.3407 21.5001ZM15.3407 23.0001C18.8058 23.0001 21.6148 20.1911 21.6148 16.726C21.6148 13.2609 18.8058 10.4519 15.3407 10.4519C11.8756 10.4519 9.06665 13.2609 9.06665 16.726C9.06665 20.1911 11.8756 23.0001 15.3407 23.0001Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAShipmentOrange);
export default __webpack_public_path__ + "static/media/CreateAShipmentOrange.89dd774e5b296ad8c3ed7c3fdd905080.svg";
export { ForwardRef as ReactComponent };